import apiClient from '../../../../services/apiClient';

/** Online Durak REST (SPEC_V141_GAMES.md §11.4). Gameplay itself goes over the game WebSocket (`durak.*`). */
export const durakAPI = {
  // GET /v1/durak/info → { enabled, stakes:["0","0.1",…], commissionPercent, tonBalance, activeMatchId|null,
  //                        recent:[{id, stake, won|null, opponentName, reason, payout, endedAt}] }
  getInfo: async () => {
    const response = await apiClient.get('/v1/durak/info');
    return response.data;
  },
};

export default durakAPI;
